import request from '@/utils/request'
import qs from 'qs'
export function policy(data) {
  return request({
    url:'/api-admin/getUploadSign',
    method:'POST',
    headers: { 'Content-Type': 'application/json' },
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/oss.js